/* ==========================================================================
   Global functions
   ========================================================================== */

function showpass() {
  var x = document.getElementById("CustomerPassword");
  if (x.type === "password") {
    x.type = "text";
  } else {
    x.type = "password";
  }
}